import en from './en';
import cn from './cn';

const messages = {
  en,
  cn
};
export default messages;